var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{attrs:{"aside-type":_vm.asideType}},[_c('template',{slot:"sidenav"},[_c('Sidenav')],1),_c('template',{slot:"main"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }